import authImg from "../assets/images/auth_img.jpg";
import csvFileIcon from "../assets/images/csv_file_icon.png";
import mainLogoWhite from "../assets/images/logo-white.png";
import mainlogo from "../assets/images/logo.png";
import ajclLogo from "../assets/images/main_logo.png";

import allCarFunctionsImg from "../assets/images/all_car_functions_img.svg";
import current_location from "../assets/images/current_location.svg";
import customerIcon from "../assets/images/customer_icon.svg";
import idle from "../assets/images/idle.svg";
import loadBookingIcon from "../assets/images/load_booking_icon.svg";
import pause from "../assets/images/pause.svg";
import quotationIcon from "../assets/images/quotation_icon.svg";
import running from "../assets/images/running.svg";
import runningRoute from "../assets/images/runningRoute.svg";
import overspeed from "../assets/images/speedometer.svg";
import stop from "../assets/images/stop.svg";
import transporterIcon from "../assets/images/transporter_icon.svg";
import trip_end from "../assets/images/trip_end.svg";
import startMap from "../assets/images/trip_start.svg";
import trip_started from "../assets/images/trip_started.svg";
import vehicleDriverImg from "../assets/images/vehicle_driver_img.svg";
import vehcileImg from "../assets/images/vehicle_img.svg";

import drivingIcon from "../assets/images/driving_icon.png";
import fuelTruck from "../assets/images/fuel_truck_img.svg";
import harshAccelerationIcon from "../assets/images/harsh_acceleration_icon.png";
import harshBrakingIcon from "../assets/images/harshbraking_icon.png";
import overSpeedIcon from "../assets/images/overspeeding_icon.png";
import idleIcon from "../assets/images/pause_icon.png";
import tripStartedIcon from "../assets/images/start_trip.png";
import stopIcon from "../assets/images/stop_icon.png";
import refuelingSensorImg1 from "../assets/images/refueling_sensor_img1.svg";
import refuelingSensorImg2 from "../assets/images/refueling_sensor_img2.svg";
import refuelImg from "../assets/images/refuel_img.png"

export const images = {
  authImg,
  mainlogo,
  csvFileIcon,
  mainLogoWhite,
  ajclLogo,

  transporterIcon,
  quotationIcon,
  customerIcon,
  loadBookingIcon,
  vehcileImg,
  vehicleDriverImg,
  allCarFunctionsImg,
  current_location,
  pause,
  idle,
  stop,
  trip_end,
  overspeed,
  running,
  trip_started,
  runningRoute,
  startMap,

  drivingIcon,
  harshAccelerationIcon,
  harshBrakingIcon,
  idleIcon,
  overSpeedIcon,
  stopIcon,

  tripStartedIcon,
  fuelTruck,
  refuelingSensorImg1,
  refuelingSensorImg2,

  refuelImg
};


export const imagesAlt = {
  transporterIcon: "Transporter Icon",
  quotationIcon: "Quotation Icon",
  customerIcon: "Customer Icon",
  loadBookingIcon: "Load Booking Icon",
  mainLogo: "Main Logo",
  ajclLogo: "AJCL Logo",
  vehcileImg: "Vehicle Image",
  vehicleDriverImg: "Vehicle Driver Image",
  allCarFunctionsImg: "All Car Functions Image",
  fuelTruck: "fuel truck image",
  refuelingSensorImg1: "refueling sensor image 1",
  refuelingSensorImg2: "refueling sensor image 2"
}